import database from '../../system/model/firebase/firebase';
import moment from 'moment';
import axios from 'axios';
import { platformTypes } from '../reducer/platformReducer';

export const initalizerTypes = {
  FETCH_COMPANY_DATA: 'company/GETTING_DATA',
  FETCH_VACANCY_DATA: 'jobs/GETTING_DATA',
  NPS_DATA: 'nps/data',
  // Variables recuperadas desde uni
  FETCH_USERS_DATA: 'users/GETTING_DATA',
  ACCEPT_USER: 'users/UPDATE_DATA',
  GETTING_COMPANIES: 'admin/GETTING_COMPANIES',
  MANAGE_COMPANY: 'admin/MANAGE_COMPANY',
  GETTING_APPLICATIONS: 'admin/GETTING_APPLICANTS',
};

export const setVacancies = (vacancies) => ({
  type: initalizerTypes.FETCH_VACANCY_DATA,
  vacancies,
});
export const updatePlatformData = (data) => ({
  type: platformTypes.UPDATE_PLATFORM_DATA,
  data,
});

export const removeOldVacancies = () => {
  return (dispatch, getState) => {
    database
      .collection(`${getState().platform.platformName}/data/vacancies`)
      .orderBy('createdAt', 'desc')
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          if (doc.data().Status) {
            if (!moment(doc.data().createdAt).add(60, 'days').isSameOrAfter(moment().valueOf())) {
              // console.log("Has been deleted ->  "+moment(doc.data().createdAt).format('(DD) - (MMMM) - (YYYY)'))
              database
                .collection(getState().platform.platformName)
                .doc('data')
                .collection('vacancies')
                .doc(doc.data().jobID)
                .update({ Status: false, outOfDate: true })
                .then((e) => {
                  if (doc.data().ATS) {
                    axios.request({
                      url: 'https://us-central1-universia-prod.cloudfunctions.net/vacancyOutOfDate',
                      method: 'POST',
                      data: {
                        email: doc.data().notifyWhomArray,
                        companyName: doc.data().companyName,
                        jobTitle: doc.data().jobTitle,
                        platformName: getState().platform.platformFullName,
                        platformURL: getState().platform.platformURL,
                      },
                      crossDomain: true,
                    });
                  } else {
                    database
                      .collection(getState().platform.platformName)
                      .doc('data')
                      .collection('companies')
                      .doc(doc.data().vacancyOwner)
                      .collection('jobs')
                      .doc(doc.data().jobID)
                      .update({ Status: false, outOfDate: true })
                      .catch((e) => console.error(e))
                      .then((m) => {
                        axios.request({
                          url: 'https://us-central1-universia-prod.cloudfunctions.net/vacancyOutOfDate',
                          method: 'POST',
                          data: {
                            email: doc.data().notifyWhomArray,
                            companyName: doc.data().companyName,
                            jobTitle: doc.data().jobTitle,
                            platformName: getState().platform.platformFullName,
                            platformURL: getState().platform.platformURL,
                          },
                          crossDomain: true,
                        });
                      });
                  }
                });
            }
          }
        });
      })
      .catch((err) => console.error(err));
  };
};

export const newUpdatePlatform = (data) => {
  return (dispatch, getState) => {
    const platform = getState().platform;
    return database
      .collection(`${platform.platformName}`)
      .doc('data')
      .update({ ...data })
      .then(() => {
        dispatch(updatePlatformData(data));
      })
      .catch((err) => console.error(err));
  };
};

export const setSkills = (data) => ({
  type: platformTypes.GET_PLATFORM_DATA,
  data,
});
export const startSetSkills = () => async (dispatch, getState) => {
  const platform = getState().platform;
  // try {
  const data = await database.collection(`UserSkills`).doc('skills').get();
  const infoData = await database.collection('TermsAndConditions').doc('Text').get();
  dispatch(newUpdatePlatform({ TermsAndConditions: infoData.data().Terms, Privacy: infoData.data().Privacy }));
  dispatch(setSkills(data.data().items));
  // } catch (err) {
  //   console.error(err);
  // }
};

export const startShowVacancies = () => {
  return (dispatch, getState) => {
    return database
      .collection(`${getState().platform.platformName}/data/vacancies`)
      .orderBy('createdAt', 'desc')
      .get()
      .then((snapshot) => {
        let jobs = [];
        snapshot.forEach((doc) => {
          if (moment(doc.data().createdAt).add(60, 'days').isSameOrAfter(moment().valueOf())) {
            jobs.push(doc.data());
          }
        });
        dispatch(setVacancies(jobs));
      })
      .catch((err) => {
        console.error(err);
      });
  };
};

/// Metodos que se reutilizaron

export const startShowApplicants = () => async (dispatch, getState) => {
  // try {
  // No pase el codigo porque no le encuentro sentido al obtener esta informacion
  const platformName = getState().platform.platformName;
  const arrayPromiseInfoCompanies = [];
  const company = await database.collection(platformName).doc('data').collection('companies').get();
  // } catch (e) {
  //   console.error(e);
  // }
};

export const setUsers = (users) => ({
  type: initalizerTypes.FETCH_USERS_DATA,
  users,
});

export const startShowUsers = () => async (dispatch, getState) => {
  // try {
  const usersDB = await database.collection(`${getState().platform.platformName}/data/users`).get();
  const users = [];
  usersDB.docs.forEach((doc) => users.push(doc.data()));
  dispatch(setUsers(users));
  // } catch (e) {
  //   console.error(e);
  // }
};
